// src/pages/Utilisateurs/PrepaPhysique/components/PrepaPhysiqueHero.jsx

import React from "react";
import {
  FaCheckCircle,
  FaChild,
  FaDumbbell,
  FaRunning,
} from "react-icons/fa";

export default function PrepaPhysiqueHero({
  adherentsCount,
  totalExercises,
  doneExercises,
  todoExercises,
  progress,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-pink-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-sky-500/30 blur-3xl" />

      <div className="relative">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          Force · Cardio · Mobilité
        </p>

        <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Vos séances à réaliser
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Les exercices sont attribués par les enseignants. Consulte les
              consignes, regarde les vidéos et valide les exercices réalisés.
            </p>
          </div>

          <div className="grid grid-cols-4 gap-2 sm:min-w-[420px]">
            <HeroStat icon={FaChild} label="Adh." value={adherentsCount} />
            <HeroStat icon={FaDumbbell} label="Total" value={totalExercises} />
            <HeroStat icon={FaCheckCircle} label="Faits" value={doneExercises} />
            <HeroStat icon={FaRunning} label="À faire" value={todoExercises} />
          </div>
        </div>

        <div className="mt-5">
          <div className="flex items-center justify-between text-xs font-bold text-slate-200">
            <span>Progression globale</span>
            <span>{progress}%</span>
          </div>

          <div className="mt-2 h-2 overflow-hidden rounded-full bg-white/10">
            <div
              className="h-full rounded-full bg-gradient-to-r from-sky-400 via-violet-400 to-pink-400 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-2.5 text-center backdrop-blur sm:p-3">
      <div className="mx-auto flex h-8 w-8 items-center justify-center rounded-xl bg-white/15 sm:h-9 sm:w-9">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-base font-bold leading-none sm:text-lg">
        {value}
      </p>

      <p className="mt-1 text-[10px] font-medium text-slate-300 sm:text-[11px]">
        {label}
      </p>
    </div>
  );
}